import styled from 'styled-components';

import { Row } from 'xpi-black-ui/Base/Grid';
import ContentBox from 'xpi-black-ui/Base/ContentBox';

export const Content = styled(ContentBox)`
  overflow: auto;
`;

export const Header = styled(Row)`
  margin-bottom: 16px;
`;

export const Container = styled.div`
  .page {
    & > div:first-child {
      /* background: #1f1f1f; */
    }
  }
`;
